<template>
    <div class="canvas__wrapper" >
        <div :id="name" class="test"></div>
        <div class="loading__overlay" v-bind:class="{fadeout: loading == 100}" >
            <span v-html="$t('OVERVIEW_LOADING01')">Prepare for landing in Tokyo</span> {{loading}}%
        </div>
    </div>
</template>

<script>
  export default {
    name: 'WorldPreview',
    props: {
      msg: Object,
        name: String,
        index: Number
    },
    data () {
      return {
        renderer: "",
        scene: "",
        c: "",
        currentC: 1,
        loader: "",
        mesh: "",
        loading: 0,
        gltf: "",
        three: Object,
          destroyFunc: Function
      }
    },
    methods:{
      leaveSite(){
        window.localStorage.removeItem('cameraState');
        const cameraState = JSON.stringify(this.c.matrix.toArray());
        window.localStorage.setItem('cameraState', cameraState);
        alert('Position wurde gespeichert.\nBitte Seite neu Laden!')
      },
      setCameraState(camera){
        let cameraState = JSON.parse(window.localStorage.getItem('cameraState'));

        if(cameraState != null){
          console.log("Found CameraState:", cameraState);
          camera.matrix.fromArray(cameraState);
          camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
        } else {
          camera.position.set( 10, -10, 10 );
        }
      } ,
      setUpRenderer(renderer){
        renderer.setSize(window.innerWidth,window.innerHeight);
        var container = document.getElementById( this.name );
        container.appendChild( renderer.domElement );
      },
      toggleCamera(){
        console.log(this.gltf);
        /*if(this.currentC == 1){
            this.c = this.gltf.cameras[2];
        } else {
            this.c = this.gltf.cameras[1];
        }*/

      }
    },
    mounted(){

      const THREE = require("three");
      const THREELoader = require("three/examples/jsm/loaders/GLTFLoader");
      const THREEHelper = require("three/examples/jsm/helpers/RectAreaLightHelper");
      const THREEDracoLoader = require("three/examples/jsm/loaders/DRACOLoader");
      const THREEControls = require("three/examples/jsm/controls/OrbitControls");
      const THREEObjLoader = require("three/examples/jsm/loaders/OBJLoader");
      this.three =THREE;


      // Setup Basic stuff
      let loader = new THREELoader.GLTFLoader();
      let scene = new THREE.Scene();
      let renderer = new THREE.WebGLRenderer({antialias:true, premultipliedAlpha:false, stencil: false, powerPreference: "high-performance",});
      let camera = new THREE.PerspectiveCamera( 1000, window.innerWidth/window.innerHeight, 0.1, 4500 );
      this.c = camera;
        scene.background = new THREE.Color( 'white' );


      // Setup Lights
        let hemiLight = new THREE.HemisphereLight(0xffffff, 0x080820, 0.6);
        hemiLight.position.set(0, -800,0);
        hemiLight.name = "hemilight";
        scene.add(hemiLight);


        let light = new THREE.SpotLight(0xffffff,0.75);
        light.position.set(-400,-1200,0);
        light.castShadow = true;
        scene.add( light );
        let light2 = new THREE.SpotLight(0xffffff,0.5);
        light2.position.set(0,-1200,-400);
        light2.castShadow = true;
        //scene.add( light2 );




      // Setup Controls
      let controls = new THREEControls.OrbitControls( camera, renderer.domElement );
      controls.update();
      //let axesHelper = new THREE.AxesHelper(50);

      // Rotate Model to match Axis
      let rotation = new THREE.Matrix4().makeRotationZ(Math.PI/2);

      // Setup Canvas and append it to container
      this.setUpRenderer(renderer);
        renderer.setClearColor( 0xffaa00, 1);
        camera.castShadow = true;
      // Detect CameraState and set it if valid
      this.setCameraState(camera);

      // Setup Scene Stuff


      let dracoLoader = new THREEDracoLoader.DRACOLoader();
      dracoLoader.setDecoderPath('examples/js/libs/draco/');
      loader.setDRACOLoader(dracoLoader);

      let _this = this;
      let url;
      let url2;

        if(process.env.NODE_ENV == 'development'){
            url = "/world_1.gltf";
        } else {
            url = "/Module/Tokyo/world_1.gltf";
        }



      loader.load(
        url,
        function(gltf){
          console.log("World: ",gltf);
          let world = gltf.scene;
          world.rotation.z = Math.PI
          scene.add(world);
          _this.gltf = world;
          world.castShadow = true;
          controls.autoRotate = true;
          controls.autoRotateSpeed = 1;
            world.traverse( function ( child ) {
                // Code for Child detection => Clickable Objects

                if(child.material){
                    child.material.metalness = 0;
                }
            } );
          animate();
        },
        function(xhr){
          console.log((xhr.loaded / xhr.total * 100) + '% loaded');
          _this.loading = (xhr.loaded / xhr.total * 100).toFixed(2);
        },
        function(error){
          console.log('An error happened:', error);
        }
      )
        let destroyed = false;
        this.destroyFunc = function(){

            destroyed = true;
            // Setup Basic stuff
            dracoLoader.dispose();
            loader.setDRACOLoader(null);
            loader = null;
            scene.dispose();
            renderer.forceContextLoss()
            renderer.domElement = null
            renderer.dispose();
            renderer = null
            camera = null;
            light = null;
            controls.dispose();
            this.c = null;
            this.renderer = null;
            this.scene = null;
            this.c = null;
            this.currentC = null;
            this.loader = null;
            this.mesh = null;
            this.gltf = null;
            this.three = null;


        }

    let rad = 0;

      function animate() {
        if(!destroyed){
            requestAnimationFrame( animate );

            controls.update();
            renderer.render( scene, camera );
        }
      }
    },
      destroyed() {
          this.destroyFunc()

          console.log("Dead")
      }
  }
</script>

<style scoped lang="scss">
    #canvas{
        position: relative;
    }
    .leave__site{
        position: absolute;
        top: 20px;
        left: 50%;
        cursor: pointer;
        transform: translate(-50%, 0);
    }
    .camera__toggle{
        position: absolute;
        top: 40px;
        left: 50%;
        cursor: pointer;
        transform: translate(-50%, 0);
    }
    .loading__overlay{
        position: fixed;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        background-color: white;
        padding: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        opacity: 1;
        transition: 0.3s ease-out 0.75s;
    }
    .loading__overlay.fadeout{
        opacity: 0;
        pointer-events: none;
    }
</style>
